module.exports = __webpack_public_path__ + "img/violet_065.c9d73a49.png";